import { FormLabel } from "@fla/components/src/Form/FormLabel";
import React, { ReactNode } from "react";
import { Controller } from "react-hook-form";

import { FormError } from "../../Form/FormError";
import GooglePlacesAutocomplete from "./apiCheck";

interface AutocompleteGooglePlacesProps {
  control: any;
  name: string;
  classes?: string;
  title?: ReactNode;
  subTitle?: string;
  onSelectAddress?: (val: any) => void;
  theme?: "light" | "dark";
}

export const AutocompleteGooglePlaces: React.FC<AutocompleteGooglePlacesProps> = ({
  control,
  name,
  classes,
  title,
  subTitle,
  onSelectAddress,
  theme = "light"
}) => {
  return (
    <article className={classes}>
      {title && (
        <FormLabel id="user.line1_address" htmlFor={name} /* error={!!error} */>
          {title}
        </FormLabel>
      )}
      {subTitle && <p className="text-sm font-light italic text-gray-500 mb-2">{subTitle}</p>}
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, name, value }, fieldState: { error } }) => (
          <>
            <GooglePlacesAutocomplete
              selectProps={{
                name,
                placeholder: "Start typing...",
                onChange: async (val: any) => {
                  if (typeof onSelectAddress === "function") {
                    onSelectAddress(val);
                  } else {
                    if (val === null || val === undefined) {
                      onChange("");
                    } else if (val.__isNew__) {
                      onChange(val.value);
                    } else {
                      onChange(val.label);
                    }
                  }
                },
                components: {
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null
                },
                value: value ? { label: value, value } : null,
                styles: {
                  control: (styles: any) => ({
                    ...styles,
                    maxWidth: "100vw",
                    backgroundColor: "#fafbfc",
                    borderRadius: "3px",
                    borderColor: "#dfe1e5",
                    ":hover": {}
                  }),
                  placeholder: (styles: any) => ({
                    ...styles,
                    color: "#7a869a"
                    // Add your search icon styles here
                  })
                }
              }}
              autocompletionRequest={{
                componentRestrictions: {
                  country: ["AU"]
                },
                types: ["geocode"]
              }}
              minLengthAutocomplete={1}
              apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY as string}
              theme={theme}
            />
            {error?.message ? <FormError error={error.message} /> : null}
          </>
        )}
      />
    </article>
  );
};
